import { useState, useContext } from "react";
import {
  Box,
  Grid,
  Stack,
  Table,
  Select,
  Avatar,
  MenuItem,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Typography,
  FormControl,
  TableContainer,
} from "@mui/material";
import moment from "moment";
//Srcs
import "../../Style/pagestyle.scss";
import EmptyData from "../../Components/Include/EmptyData/EmptyData";
import LoadingPage from "../../Utils/LoadingPage";
import FooterPagination from "../../Utils/FooterPagination";
import { SearchTextField, PageHeaderTitle } from "../../Utils/Component";
import { AuthContext } from "../../Context/AuthContext";
import useWithDimension from "../../Hooks/useWithDimension";
import useGetUserActionPagination from "../../Hooks/useGetUserActionPagination";

export default function UserAction() {
  const { t } = useContext(AuthContext);
  const { width } = useWithDimension();

  const [actionType, setActionType] = useState("All");

  const {
    page,
    limit,
    loading,
    setPage,
    tableData,
    setLoading,
    handleLimit,
    handleSearch,
    paginationData,
  } = useGetUserActionPagination({ actionType: actionType });

  return (
    <div className="page-container">
      <PageHeaderTitle
        classPage={t("class-page-title")}
        classSlash="slash-title"
        routeTo={"/setting"}
        pageTitle={t("page_setting")}
        detailTitle={t("page_user_action")}
      />

      <Box sx={{ marginTop: "20px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("search")}
            </Typography>
            <SearchTextField
              className={"text-field"}
              handleSearch={handleSearch}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_select_role")}
            </Typography>
            <FormControl className={"text-field"} fullWidth size="small">
              <Select
                value={actionType}
                onChange={(e) => setActionType(e.target.value)}
              >
                <MenuItem value="All">{t("all")}</MenuItem>
                <MenuItem value={"create"}>{t("create")}</MenuItem>
                <MenuItem value={"update"}>{t("update")}</MenuItem>
                <MenuItem value={"delete"}>{t("delete")}</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={4} lg={6} xl={8}></Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width="5%"
                >
                  {t("no")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="18%">
                  {t("thead_username")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="7%">
                  {t("thead_gender")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="15%">
                  {t("thead_date")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="10%">
                  {t("thead_action_type")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="35%">
                  {t("thead_action")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title-end")}
                  width="10%"
                ></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell
                    colSpan={10}
                    className="body-cell"
                    sx={{ bgcolor: "#fff" }}
                  >
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 || tableData?.length === undefined ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={10} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell className="body-cell-start">
                              {index + paginationData?.slNo}
                            </TableCell>
                            <TableCell className="body-cell">
                              <Stack direction="row" spacing={1.4}>
                                <Stack
                                  direction="column"
                                  justifyContent="center"
                                >
                                  <Avatar
                                    sx={{ width: 40, height: 40 }}
                                    alt={row?.actionBy?.userName}
                                    src={row?.actionBy?.profile}
                                  />
                                </Stack>
                                <Stack
                                  direction="column"
                                  justifyContent="center"
                                >
                                  <Typography className="student-name">
                                    {row?.actionBy?.familyName +
                                      " " +
                                      row?.actionBy?.userName}
                                  </Typography>
                                </Stack>
                              </Stack>
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.actionBy?.gender === "Male"
                                ? t("thead_male")
                                : t("thead_female")}
                            </TableCell>
                            <TableCell className="body-cell">
                              {moment(row?.dateTime).format(
                                "DD-MMM-YYYY HH:mm:ss A",
                              )}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.actionType === "create"
                                ? t("create")
                                : row?.actionType === "update"
                                  ? t("update")
                                  : t("delete")}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.action}
                            </TableCell>
                            <TableCell className="body-cell-end" align="right">
                              {/* <UserAction
                                editData={row}
                                setRefetch={refetch}
                                userLogin={userLogin}
                              /> */}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
